export const filterResponsesLastEntryPerDateCemex = (objetos) => {
    const users = {};
    objetos.forEach((objeto) => {
        const matricula = objeto.matricula;
        if (!(matricula in users)) {
            users[matricula] = objeto;
        } else {
            const fechaObjeto = new Date(objeto.Fecha_y_hora);
            const fechaUsuario = new Date(users[matricula].Fecha_y_hora);
            if (fechaObjeto > fechaUsuario) {
                users[matricula] = objeto;
            }
        }
    });
    return Object.values(users);
};



// Colgate Montacarga: cada fila de arrayData es UNA sesión/documento (puede haber
// varias por matrícula -- por ejemplo un reintento de evaluación llega en un documento
// aparte). Para la tabla se necesita una fila por usuario con el total acumulado de
// lecciones/evaluaciones distintas a lo largo de todas sus sesiones, no solo las de su
// última sesión -- por eso no se reutiliza filterResponsesOnlyLastEntry aquí.
export const aggregateColgateMontacargaByMatricula = (arrayData) => {
    const byMatricula = new Map();

    arrayData.forEach((row) => {
        if (!byMatricula.has(row.matricula)) {
            byMatricula.set(row.matricula, {
                base: row,
                lessonIds: new Set(),
                evaluationIds: new Set(),
                totalSeconds: 0,
            });
        }
        const acc = byMatricula.get(row.matricula);
        if (new Date(row.Fecha_y_hora) > new Date(acc.base.Fecha_y_hora)) {
            acc.base = row;
        }
        Object.values(row.evaluaciones || {}).forEach((entry) => {
            if (entry.lessonId) {
                acc.lessonIds.add(entry.lessonId);
                acc.totalSeconds += entry.timeSeconds || 0;
            } else if (entry.evaluationId) {
                acc.evaluationIds.add(entry.evaluationId);
                acc.evaluacionesIntentos = (acc.evaluacionesIntentos || 0) + 1;
                acc.totalSeconds += (entry.sections || []).reduce((sum, section) => sum + (section.sectionTimeSeconds || 0), 0);
            }
        });
    });

    return Array.from(byMatricula.values()).map((acc) => ({
        ...acc.base,
        cursosRealizados: acc.lessonIds.size,
        evaluacionesRealizadas: acc.evaluationIds.size,
        evaluacionesIntentos: acc.evaluacionesIntentos || 0,
        tiempo_total: Math.round(acc.totalSeconds / 60) + " min",
    }));
};

export const filterResponsesLastEntryPerDateMerz = (objetos) => {
    const users = {};
    objetos.forEach((objeto) => {
        const matricula = objeto.matricula;
        if (!(matricula in users)) {
            users[matricula] = objeto;
        } else {
            const fechaObjeto = new Date(objeto.Fecha_y_hora);
            const fechaUsuario = new Date(users[matricula].Fecha_y_hora);
            if (fechaObjeto > fechaUsuario) {
                users[matricula] = objeto;
            }
        }
    });
    return Object.values(users);
};